import { CustomDialog } from "components/dialogs/Dialogs";
import { useEffect, useState } from "react";
import { Button, Input } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import Grid from "@mui/material/Grid2";

type ShipLocationDialogProps = {
	open: boolean;
	onClose: () => void;
	onSave: (location: string | null) => void;
	currentLocation?: string;
	placeholder?: string;
}

const CustomerUpdateShipLocationDialog = ({ open, onClose, onSave, currentLocation, placeholder }: ShipLocationDialogProps) => {
	const [ value, setValue ] = useState<string>("");

	useEffect(() => {
		if (!open) {
			return;
		}

		setValue((currentLocation ?? "").trim());
	}, [ open, currentLocation ]);

	const onUpdate = () => {
		const trimmed = value.trim();
		onSave(trimmed.length > 0 ? trimmed : null);
		onClose();
	};

	return (
		<CustomDialog
			maxWidth="sm"
			open={open}
			onClose={onClose}
			title={intl.formatMessage({ id: "LOCATION" })}
			actions={
				<Button size="small" onClick={onUpdate}>
					{intl.formatMessage({ id: "SAVE" })}
				</Button>
			}>
			<Grid container spacing={3}>
				<Grid size={12}>
					<Input
						placeholder={placeholder || intl.formatMessage({ id: "LOCATION" })}
						value={value}
						onChange={ev => setValue(ev.target.value)}
						autoFocus />
				</Grid>
			</Grid>
		</CustomDialog>
	);
};

export default CustomerUpdateShipLocationDialog;
